import React from "react";
import { Form } from "react-bootstrap";
import { Translate } from "react-redux-i18n";

const TitlePayoutPlan = () => {
  return (
    <Form.Label>
      <h3 style={{ fontSize: '20px' }} className="mb-sm">
        <Translate value="supplierPlan.Payout_Plan" />
      </h3>
      <p style={{ color: '#98a2b3' }}>
        <Translate value="supplierPlan.Payout_Plan_note" />{' '}
      </p>
    </Form.Label>
  )
}

export default TitlePayoutPlan;